module.exports = __webpack_public_path__ + "static/img/info_plain4.5d338b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_plain4.jpg
// module id = X/On
// module chunks = 1